(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-listing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const headerHeight = document.querySelector("header")?.offsetHeight || 100; // adjust if needed

  document.querySelectorAll(".brand-listing-keys ul li a").forEach(function (element) {
    element.addEventListener("click", function (event) {
      event.preventDefault();

      // Remove "active" class from all list items
      document.querySelectorAll(".brand-listing-keys ul li").forEach(function (list) {
        list.classList.remove("active");
      });

      // Add "active" class to clicked item's parent li
      element.closest("li").classList.add("active");

      // Get the href target ID (e.g., #section1)
      const targetId = element.getAttribute("href");
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        // Get the target position minus header height
        const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerHeight - 10; // adjust 10px for spacing if needed

        // Smooth scroll with offset
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });

        // Remove "scrolled-active" from all and add to target
        document.querySelectorAll(".scrolled-active").forEach(function (el) {
          el.classList.remove("scrolled-active");
        });

        targetElement.classList.add("scrolled-active");
      }
    });
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
